import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { CardPack } from './CardPack';

const contentSelector = PropertyStripLayout<CardPack>((d, s, o, w, a) => {

    const menu = w.createMenu({
        text: 'Card Set'
    });

    const tm = (label: string, value: string) => ({ label, value });
    const opts = [
        tm('Planning', 'planning'),
        tm('T-Shirts', 'tshirts'),
        tm('Numbers', 'numbers'),
        tm('Cash', 'cash'),
        tm('Game Words', 'gameWords'),
    ];

    const items = opts.map(x =>
        w.createButton({
            text: x.label,
            onAction() {
                o.update(() => a.set('param', x.value));
                menu.update({ open: false, text: x.label });
            }
        })
    );

    menu.update({ items });
    return [menu];

});

export const cardPackPropertyLayout = LockablePropertyStripLayout<CardPack>((d, s, o, w, a) => [
    ...contentSelector(d, s, o, w, a),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
